<div class="fs-2" mat-dialog-title>
    Bienvenue sur LyBox
</div>
<div mat-dialog-content>
    Hello {{ authenticationService.currentUser.firstname }},<br/>
    <br/>
    Bienvenue sur LyBox, une application qui va vous aider dans toutes les étapes de votre chasse immobilière.<br/><br/>
    Votre abonnement LyBox est entièrement pris en charge par Purple Immobilier. Vous avez accès à toutes les fonctionnalités de LyBox sans restrictions.<br/><br/>
    Si vous avez des questions ou si vous rencontrez un problème, vous pouvez nous contacter directement via le tchat en bas à droite de la page.<br/><br/>
    Bonnes recherches !
</div>
<div mat-dialog-actions class="center">
    <button type="button" (click)="onYesClick()" class="btn btn-primary w-100">
        <i class="fa fa-check" aria-hidden="true"></i> Commencer
    </button>
</div>
